<template>
  <div class="register">
    <v-container fluid>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md6 lg4>
          <p class="display-1 text-no-wrap text-md-center font-weight-thin font-italic"></p>
          <v-card >
            <v-toolbar :color="this.getTheme.color" dark>
              <v-toolbar-side-icon></v-toolbar-side-icon>
              <v-toolbar-title>Selecionar Agendas</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon>
                <v-icon>search</v-icon>
              </v-btn>
              <v-btn icon @click="selectedAll()">
                <v-icon>check_box</v-icon>
              </v-btn>
            </v-toolbar>
            <!-- <v-text-field
              label="E-Mail"
              v-model="auth.username"
              :rules="[v => !!v || 'Você deve informar o email cadastrado!']" required
              disabled
            ></v-text-field>           -->
            <v-list two-line>
              <template v-for="(item, index) in items">
                <v-list-tile
                  :key="item.title"
                  avatar
                  ripple
                  @click="toggle(index)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>Clinica/Hosp.: {{ item.clientName }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">Nome: {{ item.name }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>CRM: {{ item.crm }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-list-tile-action-text><v-checkbox v-model="item.action"></v-checkbox></v-list-tile-action-text>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index + 1 < items.length"
                  :key="index"
                ></v-divider>
              </template>
            </v-list>
          </v-card>
          <v-card class="card-main">
            <v-card-title primary-title>
              <v-card-text>
                <v-container grid-list-md text-xs-center>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-progress-linear :indeterminate="true" v-show="loading"></v-progress-linear>
                        <v-form action="#" v-model="valid" ref="form" lazy-validation @submit.prevent="submit()">
                          <v-text-field
                            label="E-Mail"
                            v-show="auth.username"
                            v-model="auth.username"
                            :rules="[v => !!v || 'Você deve informar um número de telefone!']" required
                            disabled
                          ></v-text-field>

                          <v-btn
                            color = 'primary'
                            block
                            :disabled="!valid || loading"
                            @click="submit()"
                          >
                            Atualizar
                          </v-btn>
                        </v-form>
                  </v-flex>
                </v-layout>
                </v-container>
              </v-card-text>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        :timeout="snackbarConfig.timeout"
        :color="snackbarConfig.color"
        :multi-line="snackbarConfig.mode === 'multi-line'"
        :vertical="snackbarConfig.mode === 'vertical'"
        v-model="snackbarConfig.snackbar"
      >
      {{ snackbarConfig.text }}
      <v-btn dark flat @click.native="snackbarConfig.snackbar = false">Fechar</v-btn>
    </v-snackbar>
    </v-container>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'UpdateSchedule',
    computed: {
      progress () {
        return Math.min(100, this.auth.password.length * 10)
      },
      color () {
        return ['error', 'warning', 'success'][Math.floor(this.progress / 40)]
      },
      ...mapGetters({
        customer: 'customer'
      }),
      ...mapGetters('auth', ['getUser', 'getSearchUser']),
      ...mapGetters('app', ['getTheme'])
    },
    data: () => ({
      showPass: false,
      password: 'Password',
      rules: {
        required: value => !!value || 'Campo obrigatório!',
        min: v => v.length >= 6 || 'Campo tem que ter no mínimo 6 caracteres!'
      },
      snackbarConfig: {
        snackbar: false,
        color: 'error',
        mode: '',
        timeout: 6000,
        text: 'Erro de conexão com o servidor!'
      },
      valid: false,
      value: '',
      loading: false,
      auth: {
        myClinic: []
      },
      checkbox: false,
      items: [],
      custom: true
    }),
    async mounted () {
      // if (!this.getSearchUser.length) {
      //   this.$router.push('/auth/login')
      // }
      await this.searchEmail()
      this.searchSchedule()
      this.loading = false
      // const arrayProfessional = []
      // this.getSearchUser.map((element) => {
      //   element.map((item) => {
      //     arrayProfessional.push(item)
      //   })
      // })
      // this.items = test.map((item) => { // this.getSearchUser.map((item) => {
      //   item.action = true
      //   this.auth.name = item.name
      //   this.auth.username = item.username
      //   this.auth.myClinic.push({
      //     crm: item.crm,
      //     customer: item.customerId,
      //     client: item.client,
      //     clientName: item.clientName,
      //     state: item.state || 'PR',
      //     code: item.client,
      //     name: item.clientName,
      //     codeCustomer: item.client,
      //     customerName: item.clientName
      //   })
      //   return item
      // })
    },
    methods: {
      ...mapActions(['setSearchEmail']),
      ...mapActions('auth', ['setUpdateSchedule', 'setSearchEmailNew']),
      toggle () {},
      clear () {
        this.$refs.form.reset()
      },
      async searchSchedule () {
        const arrayProfessional = []
        await this.getSearchUser.map((element) => {
          element.map((resultElement) => {
            arrayProfessional.push(resultElement)
          })
        })
        this.items = await arrayProfessional.map((item) => { // this.getSearchUser.map((item) => {
          item.action = true
          this.auth.name = item.name
          this.auth.username = item.username
          this.auth.myClinic.push({
            crm: item.crm,
            customer: item.customerId,
            client: item.client,
            clientName: item.clientName,
            state: item.state || 'PR',
            code: item.client,
            name: item.clientName,
            codeCustomer: item.client,
            customerName: item.clientName
          })
          return item
        })
      },
      searchEmail () {
        this.loading = true
        return this.setSearchEmailNew(this.getUser.username)
          .catch((err) => {
            console.error(err)
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
      },
      submit () {
        this.$validator.validateAll()
        this.setUpdateSchedule(this.auth)
          .catch((err) => {
            this.snackbarConfig.snackbar = true
            this.snackbarConfig.text = err.response.data.result.error
          })
        // this.$http({
        //   method: 'post',
        //   url: 'https://api.spitzer.io/my-clinic-new/auth/create',
        //   data: this.auth
        // }).then(() => {
        // }).catch((error) => {
        //   console.error(error)
        //   if (error.response.data.message === 'error') {
        //     this.snackbarConfig.snackbar = true
        //     this.snackbarConfig.text = error.response.data.result.error
        //     return false
        //   }
        // })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/auth/UpdateSchedule.vue